import { getStackItemId, ItemsFolder } from '@pn/core/domain/workspace';
import type { IProjectMapper } from '@pn/core/mappers/project';
import { isEmpty } from 'lodash-es';
import { preferredOrder } from './apiStackProjectMapper';
import type { StackProjectWithListIds } from './types';

export const apiStackProjectDetailsMapper: IProjectMapper<
  StackProjectWithListIds,
  never
> = {
  toDomainProject: (stackProjectDetails) => {
    return {
      id: `stackdx|${stackProjectDetails.projectId}`,
      name: stackProjectDetails.description,
      folder: ItemsFolder.Stack,
      createdAt: stackProjectDetails.createDate,
      updatedAt: stackProjectDetails.updateDate,
      createdBy: undefined,
      workspaceItemIds: stackProjectDetails.lists
        .filter((list) => !isEmpty(list.ids))
        .sort(
          (a, b) =>
            preferredOrder.indexOf(b.dataType) -
            preferredOrder.indexOf(a.dataType)
        )
        .map((list) =>
          getStackItemId(stackProjectDetails.projectId, list.sourceLayerId)
        ),
      isFolder: true,
      isShared: false,
      isGlobal: false,
      origin: 'stackdx',
      metadata: {
        dataOriginDescription: stackProjectDetails.dataOriginDesc,
      },
    };
  },
  toTargetProjectPayload: () => {
    throw new Error('Manipulation of Stack projects is not supported');
  },
};
